import { COOKIE_NAME, defaultSession, SessionData } from "./lib";

import * as CryptoJS from "crypto-js";

import Cookies from "js-cookie";

const secretKey = process.env.REACT_APP_COOKIE_SECRET_KEY
  ? process.env.REACT_APP_COOKIE_SECRET_KEY
  : "12345";

export const encryptCookie = (plainText: string) => {
  const cipherText = CryptoJS.AES.encrypt(plainText, secretKey).toString();
  return cipherText;
};

export const decryptCookie = (cipherText: string) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  const plainText = bytes.toString(CryptoJS.enc.Utf8);
  return plainText;
};

export const getSession = async () => {
  const sessionString = Cookies.get(COOKIE_NAME);

  const session = sessionString
    ? decryptCookie(sessionString)
    : JSON.stringify(defaultSession);

  return session;
};

export const SessionLogin = async (
  userName: string,
  accessToken: string,
  userType: string,
  partyCode: string
) => {
  const newSesssion: SessionData = {
    userName,
    accessToken,
    userType,
    partyCode,
    isLoggedIn: true,
  };

  const cookieToSave = encryptCookie(JSON.stringify(newSesssion));

  Cookies.set(COOKIE_NAME, cookieToSave);
};

export const SessionLogout = async () => {
  Cookies.remove(COOKIE_NAME);
};
